import { useEffect, useState } from 'react';

/**
 * Šířky sloupců seznamu fleků — na jednom místě, ať hlavička mřížky a řádek
 * nikdy neutečou od sebe.
 *
 * `polozkaRust` = váha, kterou název bere volnou šířku (jako u surovin).
 */
export const GRID_FLEK = {
    uchyt: 40,
    polozkaMin: 200, polozkaRust: 3,
    drzitel: 150,
    hotovost: 120,
    trzba: 120,
    pohyby: 76,
    audit: 96,
    stav: 44,
    mezera: 14,
};

/**
 * Které sloupce se do šířky okna vejdou.
 *
 * Pokladna má proti surovinám jen čtyři řádky, takže se nešetří místem kvůli
 * hustotě — jde o to, aby přehled na užším notebooku nezačal zalamovat čísla.
 * Odebírá se odzadu podle toho, co nejmíň chybí: nejdřív datum auditu (je
 * i v detailu), pak počet pohybů, nakonec držitel.
 */
export function useViditelneSloupceFleku() {
    const zmer = () => {
        const w = typeof window !== 'undefined' ? window.innerWidth : 1440;
        return { audit: w >= 1180, pohyby: w >= 1040, drzitel: w >= 900 };
    };
    const [sloupce, setSloupce] = useState(zmer);
    useEffect(() => {
        const h = () => setSloupce(zmer());
        h();
        window.addEventListener('resize', h);
        return () => window.removeEventListener('resize', h);
    }, []);
    return sloupce;
}

export const fmtKc = (v, desetinna = 0) => v == null || v === ''
    ? '—'
    : new Intl.NumberFormat('cs-CZ', {
        minimumFractionDigits: desetinna, maximumFractionDigits: desetinna,
    }).format(Number(v)) + ' Kč';

/**
 * Barva fleku — zástupce kategorie ze Surovin.
 *
 * Miniatura položky v seznamu Surovin nese barvu kategorie a člověk se podle
 * ní v seznamu orientuje dřív, než přečte název. Pokladny žádnou kategorii
 * nemají, zato se rozvozové fleky **jmenují podle barev** — tak ať tu barvu
 * konečně mají i na obrazovce. Hlavní pokladna drží jantarovou, kterou měla
 * v dosavadní kartě přehledu.
 *
 * Až `cis_pokladny` dostane sloupec `barva`, přednost má on; tohle je
 * odvození pro data, která ho ještě nemají.
 */
const BARVY_NAZVU = [
    [/zelen/i, '#10B981'],
    [/modr/i, '#3B82F6'],
    [/růžov|ruzov/i, '#EC4899'],
    [/červen|cerven/i, '#EF4444'],
    [/žlut|zlut/i, '#EAB308'],
    [/fialov/i, '#8B5CF6'],
    [/oranžov|oranzov/i, '#F97316'],
];

export function barvaFleku(flek) {
    if (flek?.barva) return flek.barva;
    if (flek?.typ === 'bistro_hlavni') return '#F59E0B';
    const nalez = BARVY_NAZVU.find(([re]) => re.test(flek?.nazev ?? ''));
    return nalez ? nalez[1] : '#3B82F6';
}
